/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/dataZoom';
import { connect } from 'react-redux';
import styles from './styles.scss';


const defaultProps = {
  height: 300,
  width: null,
  legend: null,
  xAxis: null,
  yAxis: null,
  grid: null,
  dataZoom: null,
  tooltip: null,
};

const propTypes = {
  series: React.PropTypes.array.isRequired,
  categories: React.PropTypes.array.isRequired,
  legend: React.PropTypes.any,
  xAxis: React.PropTypes.any,
  yAxis: React.PropTypes.any,
  grid: React.PropTypes.any,
  dataZoom: React.PropTypes.any,
  height: React.PropTypes.number,
  tooltip: React.PropTypes.object,
};


class BarChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      series: props.series,
      categories: props.categories,
      legend: props.legend,
    };
    this.tryResizeChart = this.tryResizeChart.bind(this);
  }

  componentDidMount() {
    this.echart = this.initChart();
    this.echart.resize();
    $(window).resize(this.tryResizeChart);
  }

  componentWillReceiveProps(nextProps) {
    const { series, categories, legend } = nextProps;
    if (series !== this.props.series) {
      this.updateChart(series, categories, legend);
      this.setState({
        series: nextProps.series,
        categories: nextProps.categories,
        legend: nextProps.legend,
      });
    }
    this.tryResizeChart();
  }

  componentWillUnmount() {
    echarts.dispose($(this.chartRef));
    $(window).off('resize', this.tryResizeChart);
  }

  tryResizeChart() {
    const width = $(this.chartRef).width();
    const height = $(this.chartRef).height();
    if (height !== this.height || width !== this.width) {
      if (this.echart) {
        this.echart.resize();
      }
    }
    this.width = width;
    this.height = height;
  }

  updateChart(nextSeries, nextCategories, nextLegend) {
    const { series: thisSeries } = this.state;
    const series = nextSeries.map(s => ({
      ...s,
      name: s.name,
      data: s.data,
      type: 'bar',
      yAxisIndex: s.yAxisIndex,
    }));
    const legend = nextLegend || [];
    const option = {
      ...this.echart.getOption(),
      series,
      legend,
    };
    if (nextCategories) {
      option.xAxis = {
        data: nextCategories,
      };
    }
    if (!_.isEqual(
          _.map(thisSeries, 'name'),
          _.map(nextSeries, 'name'))) {
      // reset option
      this.echart.clear();
    }
    this.echart.setOption(option);
    this.echart.resize();
  }

  initChart() {
    const echart = echarts.init(this.chartRef);
    const series = this.state.series.map(s => ({
      ...s,
      name: s.name,
      data: s.data,
      type: 'bar',
      lineStyle: {
        normal: {
          width: 2,
        },
      },
      areaStyle: {
        normal: {
          opacity: 0.1,
        },
      },
    }));

    // xAxis
    let xAxis = {
      name: '',
      axisLine: {
        lineStyle: {
          color: '#ABB7B7',
        },
      },
      splitLine: {
        show: false,
      },
      boundaryGap: true,
    };
    if (this.props.xAxis) {
      if (_.isArray(this.props.xAxis)) {
        xAxis = this.props.xAxis.map(xa => _.extend({}, xAxis, xa));
      } else {
        xAxis = _.extend(xAxis, this.props.xAxis);
      }
    }

    // yAxis
    let yAxis = {
      name: '',
      axisLine: {
        lineStyle: {
          color: '#ABB7B7',
        },
      },
      splitLine: {
        show: false,
      },
    };
    if (this.props.yAxis) {
      if (_.isArray(this.props.yAxis)) {
        yAxis = this.props.yAxis.map(ya => _.extend({}, yAxis, ya));
      } else {
        yAxis = _.extend(yAxis, this.props.yAxis);
      }
    }

    // legends
    const legend = this.state.legend || [];
    const { grid, dataZoom, tooltip } = this.props;

    const option = {
      xAxis,
      yAxis,
      legend,
      grid,
      dataZoom,
      series,
      color: BarChart.colors,
      textStyle: {
        fontSize: 12,
        fontWeight: 300,
      },
      tooltip: {
        trigger: 'axis',
        ...tooltip,
      },
      animationEasing: 'cubicIn',
    };
    if (this.state.categories) {
      option.xAxis.data = this.state.categories;
    }
    echart.setOption(option);
    return echart;
  }

  render() {
    return (
      <div
        className={styles.chart}
        ref={(ref) => { this.chartRef = ref; }}
        style={{ height: this.props.height }}
      />
    );
  }
}

BarChart.colors = [
  '#22A7F0',
  '#00B16A',
  '#F7CA18',
  '#F9690E',
  '#EF4836',
  '#DB0A5B',
  '#663399',
  '#BF55EC',
  '#446CB3',
  '#336E7B',
  '#1BBC9B',
];
BarChart.propTypes = propTypes;
BarChart.defaultProps = defaultProps;

export default connect(
  state => ({
    collapsed: state.sidebar.collapsed,
  }),
)(BarChart);




// WEBPACK FOOTER //
// ./src/components/BarChart/index.jsx